<template>
  <div>
    <top-head />
        <div class="top">
            <img class="bg-img" src="../../../static/images/publish/1.png" />
            <div class="sub-btn sub1" @click="jumpPage"><span>与我们合作</span></div>
        </div>
        <div class="middle">
            <img class="bg-img" src="../../../static/images/publish/2.png" />
        </div>
        <div class="bottom">
            <img class="bg-img" src="../../../static/images/publish/3.png" />
            <div class="sub-btn sub2" @click="jumpPage"><span>与我们合作</span></div>
        </div>
    <homeFoot />
  </div>
</template>
<script>
  import homeFoot from '../parts/homeFoot.vue';
  import topHead from '../parts/headPart';

  export default {
    name: 'publish',
    components: {
      homeFoot,
      topHead
    },
    data() {
      return {
      }
    },
    mounted() {
        
    },
    methods: {
        jumpPage(){
            window.open('https://www.wjx.cn/vm/mk28OYk.aspx#')
        }
    }
  }
</script>
<style scoped lang="less">
 .top, .bottom{
    position: relative;
 }
 .bg-img{
    width:100%;
    vertical-align: middle;
 }

.sub-btn{
    position: absolute;
    width: 150px;
    height: 37px;
    
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.sub1{
    bottom: 26%;
    left: 50%;
    transform: translateX(-50%);
    color: #fff;
    font-size: 17px;
    background-color: rgba(255, 255, 255, 0.3);
}
.sub2{
    bottom: 22%;
    left: calc(3.5% + 75px);
    transform: translateX(-50%);
    color: #fff;
    font-size: 17px;
    background-color: #E20047;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/publish.vue